import React, { FC } from "react";
import { Interruptor } from "./interruptor";
import { MoneyCircle } from "./money-circle";
import { VemVai } from "./vem-vai";
import { Sino } from "./sino";
import { Whatsapp } from "./whatsapp";
import { Email } from "./email";
import { Instagram } from "./instagran";
import { Linkedin } from "./linkedin";
import { Telegram } from "./telegram";
import { MoneyBarras } from "./money-barras";
import { MoneyCoin } from "./money-coin";
import { MoneyCubo } from "./money-cubo";
import { MoneyGotas } from "./money-gotas";
import { Arrew } from "./arrow";
import { ArrowTop } from "./arrow-top";
import { Lock } from "./lock";
import { People } from "./people";
import { Shield } from "./shield";
import { WhatsappP } from "./whatsapp-p";
import { EmailP } from "./email-p";
import { LocalizationPin } from "./local-pin";
import { CloseX } from "./close-x";
import { UploadCloud } from "./upload-cloud";

const icons = {
  Interruptor: Interruptor,
  CloseX: CloseX,
  UploadCloud: UploadCloud,
  Lock: Lock,
  LocalizationPin: LocalizationPin,
  People: People,
  Shield: Shield,
  MoneyCircle: MoneyCircle,
  VemVai: VemVai,
  Sino: Sino,
  Whatsapp: Whatsapp,
  Email: Email,
  Instagram: Instagram,
  Linkedin: Linkedin,
  Telegram: Telegram,
  MoneyBarras: MoneyBarras,
  MoneyCoin: MoneyCoin,
  MoneyCubo: MoneyCubo,
  MoneyGotas: MoneyGotas,
  Arrow: Arrew,
  ArrowTop: ArrowTop,
  WhatsappP: WhatsappP,
  EmailP: EmailP,
};

export default icons;
